import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@heroui/react';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-red-600">403</h1>
        <h2 className="text-4xl font-semibold text-gray-800 mt-4">Access Denied</h2>
        <p className="text-gray-600 mt-4 mb-8">
          You don't have permission to access this page.
        </p>
        <div className="flex gap-4 justify-center">
          <Button onClick={() => navigate(-1)} variant="bordered">
            Go Back
          </Button>
          <Link to="/">
            <Button color="primary">Go Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
